import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import {
  fetchActiveSalons,
  getSelectedSalonId,
  setSelectedSalonId,
} from '../utils/salonScope'

const SalonContext = createContext(null)

export const SalonProvider = ({ children }) => {
  const [salons, setSalons] = useState([])
  const [selectedSalon, setSelectedSalon] = useState(null)
  const [salonReady, setSalonReady] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const init = async () => {
      try {
        const list = await fetchActiveSalons()
        if (!mounted) return
        setSalons(list)
        const stored = getSelectedSalonId()
        const match =
          list.find((s) => stored && String(s.id) === String(stored)) || list[0] || null
        if (match) setSelectedSalonId(match.id)
        setSelectedSalon(match)
      } catch (error) {
        console.error('Error initializing salons:', error)
      } finally {
        if (mounted) {
          setSalonReady(true)
          setLoading(false)
        }
      }
    }
    init()
    return () => {
      mounted = false
    }
  }, [])

  const selectSalon = useCallback((salon) => {
    setSelectedSalonId(salon?.id || null)
    setSelectedSalon(salon || null)
  }, [])

  const reloadSalons = useCallback(async () => {
    const list = await fetchActiveSalons()
    setSalons(list)
    const currentId = getSelectedSalonId()
    const match =
      list.find((s) => currentId && String(s.id) === String(currentId)) || list[0] || null
    if (match) setSelectedSalonId(match.id)
    setSelectedSalon(match)
    return list
  }, [])

  return (
    <SalonContext.Provider
      value={{
        salons,
        selectedSalon,
        salonId: selectedSalon?.id || null,
        salonReady,
        loading,
        selectSalon,
        reloadSalons,
      }}
    >
      {children}
    </SalonContext.Provider>
  )
}

export const useSalon = () => {
  const context = useContext(SalonContext)
  if (!context) {
    throw new Error('useSalon must be used within a SalonProvider')
  }
  return context
}
